/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Button, Radio } from "@mui/material";

export const StyledRadioButton = styled(Radio)({
  color: '#E4E4E7',
  "&.Mui-checked": {
    color: '#395bbd',
  },
})

export const StyledUpdateButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
  },
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    backgroundColor: "#395bbd",
    padding: "0px 15px",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  backgroundColor: "#395bbd",
  padding: "0px 15px",
  height: '35px',
});
